<div class="portfolio-container">
  <div
    *ngIf="
      model_output &&
      model_output.health !== undefined &&
      model_output.health !== null
    "
    class="portfolio-detail-container model-output-container"
  >
    <div class="phi-header">Model Output</div>
    <div class="sku-boxes">
      <div class="sku-card" *ngFor="let type of skuTypes">
        <div class="sku-title">{{ type | titlecase }} SKU</div>
        <div class="sku-count" [style.color]="getSkuColorCode(type)">
          {{ model_output[type].count }}
        </div>
        <div class="sku-multiplier">X</div>
        <div class="sku-percent" [style.color]="getSkuColorCode(type)">
          {{ model_output[type].percent }}%
        </div>
      </div>
    </div>

    <div class="total-skus">
      <div class="total-sku-title">No of Total SKUs</div>
      <div class="total-sku-data">{{ model_output.total }}</div>
    </div>

    <div class="equals">=</div>

    <div class="health-bar-wrapper">
      <label class="health-label">Portfolio Healthiness</label>
      <div class="health-meter">
        <span>0%</span>
        <app-gradient-progressbar
          [progress]="model_output.health"
        ></app-gradient-progressbar>
        <span>100%</span>
      </div>
      <p class="health-value text-center">
        {{ model_output.health | number: "1.2-2" }}%
      </p>
    </div>
  </div>
  <div
    *ngIf="
      simulation_output &&
      simulation_output.health !== undefined &&
      simulation_output.health !== null
    "
    class="portfolio-detail-container"
  >
    <div class="phi-header">Simulated Output</div>
    <div class="sku-boxes">
      <div class="sku-card" *ngFor="let type of skuTypes">
        <div class="sku-title">{{ type | titlecase }} SKU</div>
        <div class="sku-count" [style.color]="getSkuColorCode(type)">
          {{ simulation_output[type].count }}
        </div>
        <div class="sku-multiplier">X</div>
        <div class="sku-percent" [style.color]="getSkuColorCode(type)">
          {{ simulation_output[type].percent }}%
        </div>
      </div>
    </div>

    <div class="total-skus">
      <div class="total-sku-title">No of Total SKUs</div>
      <div class="total-sku-data">{{ simulation_output.total }}</div>
    </div>

    <div class="equals">=</div>

    <div class="health-bar-wrapper">
      <label class="health-label">Portfolio Healthiness</label>
      <div class="health-meter">
        <span>0%</span>
        <app-gradient-progressbar
          [progress]="simulation_output.health"
        ></app-gradient-progressbar>
        <span>100%</span>
      </div>
      <p class="health-value text-center">
        {{ simulation_output.health | number: "1.2-2" }}%
      </p>
    </div>
  </div>
</div>
